import React from "react";

export function DashbboardHelp12() {
    return (
        <div style={{
            fontFamily: 'PPMoriRegular',
            textAlign: 'justify',
            marginRight: 40,
            fontSize: '1.2em'
        }}>
            <p>The Efficient and Green Mobility scenario aims to accommodate moderate urban growth while
                transitioning from fossil fuel dependency to a transportation ecosystem dominated by clean, efficient
                vehicles, and enhanced access to local transport options. This strategy aligns with Indonesia's national
                goals to enhance urban air quality through the adoption of cleaner fuels, improved vehicle emissions
                standards, and the gradual removal of older, more polluting vehicles, as exemplified by initiatives like
                the Blue Sky Program. This is achieved through the following actions:
                <ul>
                    <li><b>Urban Development:</b> This scenario advocates for moderate urban development that integrates
                        green building standards and energy efficiency from the planning phase. The emphasis is on
                        creating compact, mixed-use neighborhoods that minimize the necessity for long commutes, thereby
                        reducing transportation-related emissions and enhancing the quality of urban life.
                    </li>
                    <li><b>Transportation:</b> A transformation of the transportation sector is central to this
                        scenario, focusing on significantly improving vehicle efficiency and encouraging the adoption of
                        electric vehicles (EVs). This is complemented by developing infrastructure that supports
                        bicycles and pedestrians, aiming to lower emissions and promote healthier, more sustainable
                        mobility options.
                    </li>
                    <li><b>Vegetation:</b> The scenario also prioritizes vegetation sequestration, seeking a balance
                        between urban growth and the conservation and augmentation of green spaces within and
                        surrounding urban areas. Efforts include restoring native forests and integrating urban green
                        spaces, which not only contribute to CO2 sequestration but also enhance urban biodiversity and
                        environmental resilience.
                    </li>
                </ul>
                By pursuing these strategies, the Efficient and Green Mobility scenario envisions a future where 
                the region’s urban growth is managed in a way that significantly reduces its environmental impact, aligning
                development with sustainability principles. This approach underscores the importance of integrated
                planning in achieving sustainable urban mobility and preserving natural ecosystems in the face of
                urbanization challenges.
            </p>
        </div>
    )
}